import ControlSidebar from '@app/modules/main/control-sidebar/ControlSidebar';
import Footer from '@app/modules/main/footer/Footer';
import Header from '@app/modules/main/header/Header';
import MenuSidebar from '@app/modules/main/menu-sidebar/MenuSidebar';
import { toggleSidebarMenu } from '@app/store/reducers/ui';
import { addWindowClass, removeWindowClass, sleep } from '@app/utils/helpers';
import { PfImage } from '@profabric/react-components';
import { loadUser, logoutUser } from '@store/reducers/auth';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { responseStatus } from '../../constants';
import { ApiPaths } from '../../helpers/api';
import { loadMenu, removeMenu } from '../../store/reducers/menu';
import intance from '../../utils/axios';
import { Spin } from 'antd';
import loading from '../../store/reducers/loading';

const Main = () => {
    const dispatch = useDispatch();
    const user = localStorage.getItem('user');
    //const isAvailableMenu = useSelector((state: any) => state.menu.isAvailableMenu);
    const menuSidebarCollapsed = useSelector(
        (state: any) => state.ui.menuSidebarCollapsed
    );
    const controlSidebarCollapsed = useSelector(
        (state: any) => state.ui.controlSidebarCollapsed
    );
    const screenSize = useSelector((state: any) => state.ui.screenSize);
    const loadingScreen = useSelector((state: any) => state.loading);
    const [isAppLoaded, setIsAppLoaded] = useState(false);

    const handleToggleMenuSidebar = () => {
        dispatch(toggleSidebarMenu());
    };

    const fetchMenu = async () => {
        /*if (!isAvailableMenu) {
            const url = ApiPaths.menu;
            await intance.get(url)
                .then(async (res) => {
                    if (res.data.trangThai == responseStatus.thanhCong) {
                        dispatch(loadMenu(res.data.duLieu));
                    } else {
                        throw res.data.thongBao;
                    }
                }).catch((err) => {
                    throw err;
                });
        } */
        const url = ApiPaths.menu;
        await intance.get(url)
            .then(async (res) => {
                if (res.data.trangThai == responseStatus.thanhCong) {
                    dispatch(loadMenu(res.data.duLieu));
                } else {
                    throw res.data.thongBao;
                }
            }).catch((err) => {
                throw err;
            });
    };

    const fetchInfo = async () => {
        try {
            if (user && user != '' && user != '{}') {
                dispatch(loadUser(JSON.parse(user)));
                await fetchMenu();
                await sleep(500);
                setIsAppLoaded(true);
            } else {
                throw '';
            }
        } catch (error) {
            dispatch(logoutUser());
            dispatch(removeMenu());
            await sleep(500);
            setIsAppLoaded(true);
        }
    };

    useEffect(() => {
        removeWindowClass('register-page');
        removeWindowClass('login-page');
        removeWindowClass('hold-transition');
        addWindowClass('sidebar-mini');
        fetchInfo();

        return () => {
            removeWindowClass('sidebar-mini');
        };
    }, []);

    useEffect(() => {
        removeWindowClass('sidebar-closed');
        removeWindowClass('sidebar-collapse');
        removeWindowClass('sidebar-open');
        if (menuSidebarCollapsed && screenSize === 'lg') {
            addWindowClass('sidebar-collapse');
        } else if (menuSidebarCollapsed && screenSize === 'xs') {
            addWindowClass('sidebar-open');
        } else if (menuSidebarCollapsed && screenSize !== 'md') {
            addWindowClass('sidebar-open');
        } else if (!menuSidebarCollapsed && screenSize !== 'lg') {
            addWindowClass('sidebar-closed');
            addWindowClass('sidebar-collapse');
        }
    }, [screenSize, menuSidebarCollapsed]);

    useEffect(() => {
        if (controlSidebarCollapsed) {
            removeWindowClass('control-sidebar-slide-open');
        } else {
            addWindowClass('control-sidebar-slide-open');
        }
    }, [screenSize, controlSidebarCollapsed]);

    const getAppTemplate = useCallback(() => {
        if (!isAppLoaded) {
            return (
                <div className="preloader flex-column justify-content-center align-items-center">
                    <PfImage
                        src="/img/ddif_logo.png"
                        alt="Quỹ Đầu tư phát triển Đà Nẵng"
                        height={100}
                        width={100}
                    />
                </div>
            );
        }
        return (
            <>
                <Header />
                <MenuSidebar />
                <div className="content-wrapper">
                    <section className="content body-content">
                        <Outlet />
                    </section>
                </div>
                <Footer />
                <ControlSidebar />
                <div
                    id="sidebar-overlay"
                    role="presentation"
                    onClick={handleToggleMenuSidebar}
                    onKeyDown={() => { }}
                />
            </>
        );
    }, [isAppLoaded]);

    return <div className="wrapper"><Spin spinning={loadingScreen.isLoading} fullscreen size="large" />{getAppTemplate()}</div>;
};

export default Main;
